/** The integration's key: its registry key, and the type of its requests. */
export const DATABRICKS_INTEGRATION_KEY = "databricks" as const;

/**
 * The connector's Lambda function name, which is also its image name. The
 * install terraform deploys the connector under it, and P0 invokes it by it.
 */
export const DATABRICKS_CONNECTOR_FUNCTION_NAME = "p0-connector-databricks";

/**
 * The Databricks account consoles, one per cloud Databricks runs on.
 *
 * The connector only accepts these (`DATABRICKS_ACCOUNTS_HOSTS` in
 * p0-connector-databricks), because it sends its AWS identity token to
 * whichever console a request names. They are repeated here because the
 * connector package can't be bundled into the frontend.
 */
export const DatabricksAccountsUrls = [
  "https://accounts.cloud.databricks.com", // AWS
  "https://accounts.cloud.databricks.us", // AWS GovCloud
  "https://accounts.azuredatabricks.net", // Azure
  "https://accounts.gcp.databricks.com", // GCP
] as const;

/**
 * The domain each account console's workspaces are served from. A workspace's
 * URL is `https://<host>` on its account's domain.
 *
 * The connector sends the service principal's Databricks token to a
 * workspace's URL, so it only accepts a host on one of these
 * (`DATABRICKS_HOSTS` in p0-connector-databricks). They are repeated here for
 * the same reason as {@link DatabricksAccountsUrls}.
 */
export const DatabricksWorkspaceDomains = {
  "https://accounts.cloud.databricks.com": "cloud.databricks.com",
  "https://accounts.cloud.databricks.us": "cloud.databricks.us",
  "https://accounts.azuredatabricks.net": "azuredatabricks.net",
  "https://accounts.gcp.databricks.com": "gcp.databricks.com",
} as const satisfies Record<(typeof DatabricksAccountsUrls)[number], string>;

/**
 * The `aud` the connector requests its AWS identity tokens with
 * (`DATABRICKS_TOKEN_AUDIENCE` in p0-connector-databricks), which every
 * Databricks federation policy that trusts the connector must expect.
 * Repeated here for the same reason as {@link DatabricksAccountsUrls}.
 */
export const DATABRICKS_TOKEN_AUDIENCE = "databricks";
